import React from 'react';

const ActionEnergy = ({ color="#fff", size = "20" }: { size?: string | number; color?: string }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.8913 9.63343L10.7006 17.1314C10.2248 17.8179 9.14798 17.482 9.14798 16.6461V11.7042H4.80877C4.1214 11.7042 3.71641 10.9322 4.10845 10.3666L9.2991 2.86858C9.7749 2.18207 10.8517 2.51799 10.8517 3.35388V8.29583H15.1909C15.8774 8.29583 16.2824 9.06782 15.8913 9.63343Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default ActionEnergy;
